import { Component, Input } from '@angular/core';
import { BookingState } from '@markant-platform/cartridge/model';
import { UsageRightState } from '@markant-platform/usage-right/model';

@Component({
  selector: 'markant-platform-management-tile-eligible-user',
  templateUrl: './eligible-user.component.html',
  styleUrls: ['./eligible-user.component.scss'],
})
export class EligibleUserManagementTileComponent {
  @Input({ required: true }) variantId!: string;
  @Input({ required: true }) bookingState!: BookingState;
  @Input() usageRightState: UsageRightState | undefined;
}
